const mutations = {
    SET_LIST(state, data) {
        state.list = data.map(offer => {
            const landings = offer.landings.map(item => item.name)

            offer.landingsList = landings
            offer.landingsLength = landings.length
            offer.active_name = offer.is_active ? 'On' : 'Off'
            offer.landings = offer.landings.map(landing => {
                landing.full_name = `${landing.id} - ${landing.name}`

                return landing
            })

            return offer
        })
    },

    SET_PUT_STATUS(state, index) {
        state.list[index].is_active === 1 ? state.list[index].is_active = 0 : state.list[index].is_active = 1
    },

    SET_NEW_OFFER(state, data) {
        state.list.push(data)
    }
}

export default mutations
